// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import PeoplesSvg from '@rsuite/icon-font/lib/people/Peoples';
var Peoples = createSvgIcon({
  as: PeoplesSvg,
  ariaLabel: 'peoples',
  category: 'people',
  displayName: 'Peoples'
});
export default Peoples;